import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, Validator, FormBuilder } from '@angular/forms';
import{LoopBackAuth, listadosService, asignaturaAreaService} from '../../services/api-rest.service';
import{MessageService} from '../../services/message.service';
import{ModalFormAsignaturaAreaComponent } from '../../modal/modal-form-asignatura-area/modal-form-asignatura-area.component'
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'form-asignatura',
  templateUrl: './form-asignatura.component.html',
  providers:[LoopBackAuth,listadosService,asignaturaAreaService, MessageService]
})
export class FormAsignaturaComponent implements OnInit {
  @Input() asignatura : FormGroup
  @Input() preview : boolean = true
  estados: any[]
  areas: any[]
  asignaturasTipos: any[]

  constructor(
    private listadosService: listadosService,
    private asignaturaAreaService:asignaturaAreaService,
    private fb: FormBuilder,
    private modalService: NgbModal,
  ) { }

  ngOnInit() {
    this.listadosService.estados().subscribe(lista => this.estados = lista.filter(item => item.id == 0 || item.id == 1))
    this.listadosService.listaAsignaturaTipo().subscribe(
      result =>{
        console.log("lista Asignaturas-->", result)
        this.asignaturasTipos = result
      } 
    )
    this.searchAreas()
  }
  searchAreas(){
    this.asignaturaAreaService.listaActivas().subscribe(lista=> this.areas = lista)
  }
  modalAddArea(){
    let  fromAsignaturasTemp = this.fb.group({
      id:[null],
      descripcion:[null],
      estado:[1],
    })
    /**
     * Ventana  se envia formGroup con la informacion y devuelve modificado si se guardo
     */
   const ventana = this.modalService.open(ModalFormAsignaturaAreaComponent,{
     size:'sm'
   })
    ventana.componentInstance.fromAsignaturaAreas = fromAsignaturasTemp
    ventana.result.then((result)=>{
      this.searchAreas()
    },(reason) =>{
      console.log("salir")
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/element/formularios/form-asignatura.component.ts